
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * TriStateEnablement enum
 */
class TriStateEnablement {
  /**
   * Initialize enum with a given value
   * @param {TriStateEnablement|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof TriStateEnablement) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!TriStateEnablement}
   * @param {!TriStateEnablement} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TriStateEnablement)) {
      throw new TypeError('Instance of TriStateEnablement is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!TriStateEnablement}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!TriStateEnablement}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === TriStateEnablement.INHERITED.value) {
      return 'INHERITED'
    }
    if (this.value === TriStateEnablement.ENABLED.value) {
      return 'ENABLED'
    }
    if (this.value === TriStateEnablement.DISABLED.value) {
      return 'DISABLED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!TriStateEnablement}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!TriStateEnablement}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!TriStateEnablement} Created enum
   */
  static fromObject (other) {
    return new TriStateEnablement(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
TriStateEnablement.INHERITED = new TriStateEnablement(0 + 0)
// noinspection PointlessArithmeticExpressionJS
TriStateEnablement.ENABLED = new TriStateEnablement(0 + 1)
// noinspection PointlessArithmeticExpressionJS
TriStateEnablement.DISABLED = new TriStateEnablement(0 + 2)

export { TriStateEnablement };

/**
 * Fast Binary Encoding TriStateEnablement field model
 */
class FieldModelTriStateEnablement extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelTriStateEnablement}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelTriStateEnablement}
   * @param {TriStateEnablement=} defaults Default value, defaults is new TriStateEnablement()
   * @returns {!TriStateEnablement} Result value
   */
  get (defaults = new TriStateEnablement()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new TriStateEnablement(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelTriStateEnablement}
   * @param {!TriStateEnablement} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelTriStateEnablement };
